module.exports = __webpack_public_path__ + "img/2f_l_yanagi.e8c946f8.png";